<template>
    <div class="h-full w-full text-left p-8 space-y-8">
        <!-- Student Info -->
        <div class="flex flex-col sm:flex-row items-center gap-6">
            <img :src="profilePicture" alt="Student Photo" class="w-24 h-24 rounded-full object-cover border" />
            <div>
                <h2 class="text-xl font-semibold text-gray-800">{{ item.user.name }}</h2>
                <p class="text-sm text-gray-600">Email: {{ item.user.email }}</p>
                <p class="text-sm text-gray-600">Student ID: {{ item.user.students.student_id }}</p>
            </div>
        </div>

        <!-- Event Info -->
        <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-2">Event Details</h3>
            <div class="bg-gray-50 border rounded-lg p-4 text-sm text-gray-700">
                <p><span class="font-medium">Event Name:</span> {{ item.event.title }}</p>
                <p><span class="font-medium">Date:</span> {{ eventDate }}</p>
                <p v-if="item.event.display_time"><span class="font-medium">Time:</span> {{ eventTime }}</p>
                <p><span class="font-medium">Location:</span> {{ item.event.location }}</p>
                <p v-if="item.event.focal_point"><span class="font-medium">Focal Point:</span> {{ item.event.focal_point
                }}</p>
                <p v-if="item.event.event_type == 'Virtual Career Fair'"><span class="font-medium">Participating
                        Employers:</span> {{ participatingEmployers }}</p>
            </div>
        </div>

        <!-- Submitted CVs -->
        <div v-if="item.event.event_type == 'Virtual Career Fair'" class="pb-8">
            <h3 class="text-lg font-semibold text-gray-700 mb-2">CV Submitted To</h3>
            <ul class="space-y-3">
                <li v-for="(obj, index) in item.user.event_employer_attachments" :key="index"
                    class="bg-gray-50 border rounded-md p-4 flex justify-between items-center">
                    <div>
                        <p class="font-medium text-gray-800">{{ obj.event_employer.partner.en_company_name }}</p>
                    </div>
                    <a :href="getUrl(obj.path)" target="_blank"
                        class="text-blue-600 hover:underline text-sm font-medium">
                        View CV
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "view-registered-student",
    props: ["item"],
    computed: {
        profilePicture() {
            if (this.item.user.profile_picture_url == "/storage/alumni-profile-pictures/default-avatar.jpg") {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${this.item.user.students.student_id}/${this.item.user.students.entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + this.item.user.profile_picture_url;
            }
        },
        eventDate() {
            const start_date = new Date(this.item.event.start_date);
            const end_date = new Date(this.item.event.end_date);

            const startMonth = start_date.toLocaleString("default", {
                month: "short",
            });
            const startDate = start_date.getDate();
            const endDay = end_date.getDate();
            const year = start_date.getFullYear();

            let formattedDate = startMonth;

            if (this.item.event.display_day !== false) {
                if (startDate !== endDay) {
                    formattedDate += ` ${startDate}-${endDay}, ${year}`;
                } else {
                    formattedDate += ` ${startDate}, ${year}`;
                }
            } else {
                formattedDate += ` - ${year}`;
            }

            return formattedDate;
        },
        eventTime() {
            return `${this.formatTime(this.item.event.start_date)} - ${this.formatTime(this.item.event.end_date)}`;
        },
        participatingEmployers() {
            return this.item.event.event_employers.map(item => item.partner.en_company_name).join(', ');
        },
    },
    methods: {
        formatTime(datetime) {
            const date = new Date(datetime);
            const options = { hour: "numeric", minute: "numeric", hour12: true };
            return date.toLocaleTimeString([], options);
        },
        getUrl(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
    },
}
</script>

<style lang="scss" scoped></style>